import extendNode from '../extendNode.mjs'
import useAbstractNode from '../_ABSTRACT/useAbstractNode.jsx'
import meta from './metaIe_1.mjs'
import FormChoose from './FormChooseIe_1.jsx'
import TableChoose from './TableChooseIe_1.jsx'
import api from './apiIe_1.mjs'

export default () => {
    const AbstractNode = useAbstractNode()

    return extendNode(AbstractNode, {
        ...meta,
        api,
        FormChoose,
        TableChoose,
    })
}
